import TwoColumns from './TwoColumns.component';

export default TwoColumns;
